import React from 'react';

import AdminBrowseHomeEditPage from 'app/components/admin/browse/home/AdminBrowseHomeEditPage';

export function AdminBrowseHomeEditPageRoute() {
  return <AdminBrowseHomeEditPage browseHomePageId={null} />;
}

export default AdminBrowseHomeEditPageRoute;
